<template>
    <v-flex xs12>
        <transaction-hub v-if="canViewTransactionHub"></transaction-hub>
    </v-flex>
</template>

<script>
  import MyQuickLinks from "../Tools/QuickLinks/MyQuickLinks";
  import TransactionHub from "../../components/ChapterPage/TransactionHub/TransactionHub";
  import {storeGetters} from "@/store/storeGetters.constant";
  import { routerNames } from "../appCommon.constants";
  import {mapGetters} from "vuex";
  import {userTypes} from "@/components/MyAccount/myaccount.constants";

  export default {
    name: "HomeLeftSidebar",
    components: {
      MyQuickLinks,
      TransactionHub,
    },
    data: () => {
      return {
        routerNames,
      };
    },
    computed: {
      ...mapGetters({
        profileInformation: `myAccount/${storeGetters.profileInformation}`,
      }),
      canViewTransactionHub() {
        return this.profileInformation && this.profileInformation.recordTypeName === userTypes.MEMBER && this.$route.name === this.routerNames.HOME;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../common/styles/_colors.scss";
  @import "../../common/styles/_commonClasses.scss";
</style>
